module.exports = __webpack_public_path__ + "img/E5.1523f6a3.svg";